import { render, staticRenderFns } from "./FooterNavigationAbout.vue?vue&type=template&id=08d7c4ca"
import script from "./FooterNavigationAbout.vue?vue&type=script&lang=js"
export * from "./FooterNavigationAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports